import { memo, ReactNode } from 'react'

export type MenuSharedBlockProps = {
  children: ReactNode
}

export const MenuSharedBlock = memo<MenuSharedBlockProps>(({ children }) => {
  return <>{children}</>
})

MenuSharedBlock.displayName = 'MenuSharedBlock'
